import ActionTypeManagementModal from '@/features/actionType/components/ActionTypeManagementModal';
import { useAuthStore } from '@/shared/stores';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownSection,
} from '@heroui/react';
import { HiUsers } from 'react-icons/hi2';
import { MdLogout, MdMessage, MdSettings } from 'react-icons/md';
import { TbListDetails } from 'react-icons/tb';
import { useNavbarProfile } from '../hooks/useNavbarProfile';
import { IconType } from '../models/navbar.model';
import { profileMenu } from '../utils/navbarLinks';
import NavbarButtonImgProfile from './NavbarButtonImgProfile';
import NotificationsHistoryModal from './NotificationsHistoryModal';

const iconMap = {
  [IconType.USER]: <HiUsers />,
  [IconType.SETTINGS]: <MdSettings />,
  [IconType.MESSAGE]: <MdMessage />,
  [IconType.LOGOUT]: <MdLogout />,
  [IconType.ACTION_TYPE]: <TbListDetails />,
};

const NavbarProfile = () => {
  const { userProfile, handleMenuAction, actionTypeModal, notificationsModal } =
    useNavbarProfile();

  const { es_admin } = useAuthStore();
  const filteredMenu = profileMenu.filter((item) => {
    if (item.key === 'usuario' || item.key === 'tipos-acciones') {
      return es_admin === true;
    }
    return true;
  });

  return (
    <>
      <Dropdown placement="bottom-end" backdrop="blur">
        <NavbarButtonImgProfile name={userProfile.name} />

        <DropdownMenu aria-label="Menú desplegable del perfil" variant="flat">
          <DropdownSection title={'Bienvenido'} showDivider>
            <DropdownItem
              key="userName"
              className="h-14 gap-2"
              description={userProfile.email}
            >
              {userProfile.name}
            </DropdownItem>
          </DropdownSection>

          <DropdownSection title="Acciones del perfil">
            {filteredMenu.map(({ key, icon, label }) => (
              <DropdownItem
                key={key}
                color={key === 'cerrar-sesion' ? 'danger' : 'primary'}
                startContent={icon ? iconMap[icon] : null}
                onPress={() => handleMenuAction(key)}
              >
                {label}
              </DropdownItem>
            ))}
          </DropdownSection>
        </DropdownMenu>
      </Dropdown>

      <NotificationsHistoryModal
        isOpen={notificationsModal.isOpen}
        onClose={notificationsModal.closeModal}
      />

      <ActionTypeManagementModal
        isOpen={actionTypeModal.isOpen}
        onClose={actionTypeModal.closeModal}
      />
    </>
  );
};

export default NavbarProfile;
